// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"86b57f67","455":"cea0f1a6","977":"53917213"}[chunkId] + ".chunk.js";
};